import { useMemo } from "react";
import { resolveViewerTimezone } from "@/lib/timezone";

/** The viewer's own timezone (browser / device), used for displaying saved
 *  order times. This is the one place the app reads the browser timezone;
 *  pass the result down rather than reading it again in lib code.
 *  See docs/TIMEZONES.md. */
export function useViewerTimezone(): string {
  return useMemo(() => resolveViewerTimezone(), []);
}
